var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 15.0078C14.7227 13.5078 13.1016 12.5 11.25 12.5H8.75C6.89844 12.5 5.27734 13.5078 4.41406 15.0078C5.78906 16.5391 7.78125 17.5 10 17.5C12.2188 17.5 14.2109 16.5352 15.5859 15.0078ZM0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10ZM10 10.625C10.7459 10.625 11.4613 10.3287 11.9887 9.80124C12.5162 9.27379 12.8125 8.55842 12.8125 7.8125C12.8125 7.06658 12.5162 6.35121 11.9887 5.82376C11.4613 5.29632 10.7459 5 10 5C9.25408 5 8.53871 5.29632 8.01126 5.82376C7.48382 6.35121 7.1875 7.06658 7.1875 7.8125C7.1875 8.55842 7.48382 9.27379 8.01126 9.80124C8.53871 10.3287 9.25408 10.625 10 10.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.faa678aff217c505a72995f83c3ad791.svg";
export { ForwardRef as ReactComponent };